function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1514 0.740234L20.7557 8.34453V23.5531C20.7557 24.2254 20.4886 24.8701 20.0132 25.3455C19.5379 25.8208 18.8932 26.0879 18.2209 26.0879H3.0123C2.34004 26.0879 1.69532 25.8208 1.21995 25.3455C0.744594 24.8701 0.477539 24.2254 0.477539 23.5531V3.275C0.477539 2.60274 0.744594 1.95801 1.21995 1.48265C1.69532 1.00729 2.34004 0.740234 3.0123 0.740234H13.1514ZM18.2209 23.5531V9.61191H11.884V3.275H3.0123V23.5531H18.2209ZM10.6166 13.4141L15.6861 18.4836H12.5177V22.2857H8.71553V18.4836H5.54707L10.6166 13.4141Z",
  fill: "white"
});

var SvgResume = function SvgResume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resume.746a1465.svg";
export { ForwardRef as ReactComponent };